import { api } from "./client";
import type { NotificationCampaign, NotificationCreateInput } from "./types";

/** docs/API_CONTRACT.md - GET /api/admin/notifications */
export function listNotifications(): Promise<NotificationCampaign[]> {
  return api.get<NotificationCampaign[]>("/admin/notifications");
}

/** docs/API_CONTRACT.md - POST /api/admin/notifications */
export function createNotification(
  payload: NotificationCreateInput,
): Promise<NotificationCampaign> {
  return api.post<NotificationCampaign>("/admin/notifications", payload);
}

/** docs/API_CONTRACT.md - POST /api/admin/notifications/{notificationId}/send-now */
export function sendNotificationNow(notificationId: string): Promise<NotificationCampaign> {
  return api.post<NotificationCampaign>(
    `/admin/notifications/${encodeURIComponent(notificationId)}/send-now`,
  );
}

/** docs/API_CONTRACT.md - POST /api/admin/notifications/{notificationId}/cancel */
export function cancelNotification(notificationId: string): Promise<NotificationCampaign> {
  return api.post<NotificationCampaign>(
    `/admin/notifications/${encodeURIComponent(notificationId)}/cancel`,
  );
}
